module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3RbNK"))).then(() => module.bundle.root('3a9aZ'));